import { tempoApi } from '@/lib/api/tempoApi';
import type {
  CreateCustomField,
  CustomField,
  UpdateCustomField,
} from '@/lib/api/types/customField';
import type { PickListOption } from '@/lib/api/types/picklistOption';

const getCustomFields = async () =>
  await tempoApi().get('api/v1/item-store/fields').json<CustomField[]>();

const getCustomFieldDetails = async (params: { customFieldId: number }) =>
  await tempoApi().get(`api/v1/item-store/fields/${params.customFieldId}`).json<CustomField>();

const getPicklistOptions = async (params: { customFieldId: number }) =>
  await tempoApi()
    .get(`api/v1/item-store/fields/${params.customFieldId}/picklist-options`)
    .json<PickListOption[]>();

const createCustomField = async ({ data }: { data: CreateCustomField }) =>
  await tempoApi().post('api/v1/item-store/fields', { json: data }).json<CustomField>();

const patchCustomField = async ({
  customFieldId,
  data,
}: {
  customFieldId: number;
  data: UpdateCustomField;
}) =>
  await tempoApi()
    .patch(`api/v1/item-store/fields/${customFieldId}`, { json: data })
    .json<CustomField>();

export const CustomFieldsApi = {
  getCustomFields,
  getCustomFieldDetails,
  createCustomField,
  patchCustomField,
  getPicklistOptions,
} as const;
